import { authFetch } from './client';

// Per-user settings are now just the profile (display name). LLM API keys moved
// to the organization level — see src/api/orgKeys.js.
export const getSettings = () => authFetch('/api/settings');
export const getProfile = () => authFetch('/api/settings/profile');
// preferredName omitted (undefined) leaves a stored one alone; '' clears it.
export const updateProfile = (displayName, preferredName) =>
  authFetch('/api/settings/profile', {
    method: 'PUT',
    body: JSON.stringify({ displayName, preferredName }),
  });
